// extracted by mini-css-extract-plugin
export default {"MyCreateDialog":"MyCreateDialog_MyCreateDialog__y26t3","photo":"MyCreateDialog_photo__X0+TD","containerImage":"MyCreateDialog_containerImage__mUaJp"};